var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('div',{staticClass:"overlay"},[_c('div',{staticClass:"retention-dialog"},[_c('div',{staticClass:"actions"},[_c('button',{staticClass:"btn cancel-btn",on:{"click":_vm.onCancel}},[_vm._v("继续退出")]),_c('button',{staticClass:"btn confirm-btn",on:{"click":_vm.onConfirm}},[_vm._v("联系客服")])])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }